module.exports = __webpack_public_path__ + "static/media/messy-fm-site-logo.925072d1.png";